export default function copyText(text, success, error) {
  if (document.execCommand('copy')) {
    try {
      // 创建一个文本框，并把 innerHTML 换成要写入的文本
      const txa = document.createElement('textarea');
      txa.innerHTML = text;
      document.body.appendChild(txa);
      // 选中文本
      txa.select();
      // 复制
      const res = document.execCommand('copy');
      // 从文档中移除
      document.body.removeChild(txa);
      if (res) {
        if (success) {
          success();
        }
        return;
      }
    } catch (err) {
      console.log(err);
      if (error) {
        error();
      }
    }
  }

  if (navigator.clipboard) {
    // 直接调用API即可
    navigator.clipboard.writeText(text).then(success).catch(error);
  } else if (error) {
    error();
  }
}
